/* eslint-disable jsx-a11y/anchor-is-valid */
import { Breadcrumbs, Stack } from '@mui/material';
import get from 'lodash-es/get';
import React, { ReactNode } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { ADMIN_CONTRACT_EDIT_URL } from '../../constants/routeUrls';
import { useContractConfigurationContext } from '../../hooks/useContractConfigurationContext';
import { Link } from '../../inmarkit';
import KPIHeader from './KPIHeader';

interface ContractConfigurationContractProps {
  title?: ReactNode[];
}

function ContractConfigurationBreadcrumb({ title = [] }: ContractConfigurationContractProps) {
  const navigate = useNavigate();
  const contractConfigurationContext = useContractConfigurationContext();

  const contractData: any = get(contractConfigurationContext, 'contractData');
  const lineItemsData: any = get(contractConfigurationContext, 'lineItemsData');

  return (
    <Stack p={2} justifyContent="space-between">
      <Breadcrumbs sx={{ fontSize: '12px' }}>
        <Link href="../../../" color="#616161">
          Home
        </Link>
        {title.length > 0 && (
          <Link
            onClick={() => navigate(generatePath(ADMIN_CONTRACT_EDIT_URL, { id: contractData.id.toString() }))}
            color="#616161"
          >
            {contractData?.name}
          </Link>
        )}
        {title.length === 0 && <span>{contractData?.name}</span>}
        {title}
      </Breadcrumbs>
      {lineItemsData && <KPIHeader contract={contractData} lineItems={lineItemsData} />}
    </Stack>
  );
}

export default ContractConfigurationBreadcrumb;
